import warning from 'warning';
var warned = {};

var warningOnce = function warningOnce(condition, message) {
  if (warned[message]) {
    return;
  }

  warning(condition, message);
  warned[message] = !condition;
};

export default warningOnce;